import { createFocusTrap } from 'focus-trap';
import { add, listen, qs, remove } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { on } from '@/glow/events';

const classes = {
  visible: 'is-visible',
  active: 'is-active',
};

const selectors = {
  closeBtn: '[data-modal-close]',
  modalContent: '.modal__content',
  overlay: '.modal__overlay',
  modalInner: '.modal__inner',
};

export default function modal(node) {
  const focusTrap = createFocusTrap(node, { allowOutsideClick: true });
  const modalContent = qs(selectors.modalContent, node);
  const modalInner = qs(selectors.modalInner, node);

  const events = [
    listen(qs(selectors.closeBtn, node), 'click', e => {
      e.preventDefault();
      _close();
    }),
    listen(qs(selectors.overlay, node), 'click', () => _close()),
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) _close();
    }),
    on('modal:open', (state, { modalContent }) => {
      _renderModalContent(modalContent);
      _open();
    }),
  ];

  const _renderModalContent = content => {
    const clonedContent = content.cloneNode(true);
    modalContent.innerHTML = '';
    modalContent.appendChild(clonedContent);
  };

  const _open = () => {
    add(node, classes.visible);
    add(node, classes.active);
    focusTrap.activate();
    disableBodyScroll(modalInner);
  };

  const _close = () => {
    modalContent.innerHTML = '';

    focusTrap.deactivate();
    remove(node, classes.active);
    enableBodyScroll(modalInner);

    setTimeout(() => {
      remove(node, classes.visible);
    }, 400);
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
